module.exports = __webpack_public_path__ + "wave-1.5znSC83C.svg";